import classNames from "classnames";
import moment from "moment";
import { createRef, Component } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons";

export class Notification extends Component {
    constructor(props) {
        super();
        this.elRef = createRef();
    }
    
    componentDidUpdate() {
        if (this.props.active) {
            // this.elRef.current.scrollIntoView();
            
            this.elRef.current.scrollIntoView(false);
        }
    }
    
    render() {
        const getCloseIcon = (show) => {
            if (show) {
                return (<FontAwesomeIcon title="clear notification" icon={faTimesCircle}/>);
            }
            return null;
        };
        return (
            <div ref={this.elRef} className={classNames("notification", { active: this.props.active })}>
                <div onClick={this.props.onClick} className={classNames("title", { read: this.props.read })}>{this.props.title}</div>
                <div className="delete-notification" onClick={this.props.clearNotification}>{getCloseIcon(this.props.fromTopBar)}</div>
                <div onClick={this.props.onClick} className="description">{this.props.description}</div>
                <div onClick={this.props.onClick} className="triggered">{moment.utc(this.props.date).format("MMMM DD, YYYY")}</div>
            </div>
        );
    }
}
